"use client";

const BASE_URL = process.env.NEXT_PUBLIC_API_URL

const buildUrlWithSearchParams = (url, params) => {
  if (!params || Object.keys(params).length === 0) return url;
  
  let result = "";

  Object.keys(params).forEach((key, i) => {
    if (!params[key]) {
      delete params[key];
    } else {
      if(i === 0) {
        result += `${key}=${params[key]}`
      } else {
        result += `&${key}=${params[key]}`
      }
    }
  });

  return `${url}?${result}`;
};

export const getApi = async (
  requestUrl = "",
  params = {},
  options = {}
) => {
  try {
    let url = buildUrlWithSearchParams(requestUrl, params);

    let response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      cache: "no-cache",
      headers: {
        "Content-Type": "application/json",
      },
      ...options
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    let data = await response.json();
    return data;
  } catch (error) {
    console.error('Error:', error);
    throw error;
  }
}

export const postApi = async (
  requestUrl,
  body,
  options,
  params
) => {
  try {
    let url = buildUrlWithSearchParams(requestUrl, params);

    let response = await fetch(`${BASE_URL}/${url}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body),
      ...options
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    let data = await response.json();

    return data;
  } catch (error) {
    console.error('Error:', error);
    throw error;
  }
}

export const patchApi = async (
  requestUrl,
  body,
  options,
  params
) => {
  try {
    let url = buildUrlWithSearchParams(requestUrl, params);

    let response = await fetch(`${BASE_URL}/${url}`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body),
      ...options
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    let data = await response.json();

    return data;
  } catch (error) {
    console.error('Error:', error);
    throw error;
  }
}

export const deleteApi = async (
  requestUrl,
  options
) => {
  try {
    let url = buildUrlWithSearchParams(requestUrl);

    let response = await fetch(`${BASE_URL}/${url}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json'
      },
      ...options
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    let data = await response.json();
    
    return data;
  } catch (error) {
    console.error('Error:', error);
    throw error;
  }
}
